export interface ReviewPlatform {
  name: string;
  label: string;
  href: string;
  description: string;
  cta: string;
}

export interface GoogleReview {
  authorName: string;
  rating: 5;
  text: string;
}

export const googleBusinessProfileUrl =
  'https://www.google.com/maps/place/OKTshirt/@52.5373889,-1.9131485,19.5z/data=!4m6!3m5!1s0x4870a30e8ca8ca13:0x1f935f32ecde8253!8m2!3d52.5377046!4d-1.9129045!16s%2Fg%2F11r97trw7y';

export const reviewPlatforms: ReviewPlatform[] = [
  {
    name: 'Google Reviews',
    label: 'Google',
    href: googleBusinessProfileUrl,
    description: 'Read customer feedback for the Birmingham print and embroidery shop.',
    cta: 'View Google reviews',
  },
  {
    name: 'Trustpilot',
    label: 'Trustpilot',
    href: 'https://www.trustpilot.com/review/oktshirt.co.uk',
    description: 'Find OKTshirt on Trustpilot and check independent review activity.',
    cta: 'Open Trustpilot',
  },
  {
    name: 'Yell',
    label: 'Yell',
    href: 'https://www.yell.com/biz/oktshirt-birmingham-10206524/',
    description: 'See the OKTshirt business listing, contact details and customer feedback.',
    cta: 'Open Yell listing',
  },
];

export const googleReviewPlatform = reviewPlatforms[0];

export const secondaryReviewPlatforms = reviewPlatforms.filter(
  (platform) => platform.label !== 'Google'
);

export const googleReviews: GoogleReview[] = [
  {
    authorName: 'Emma Calveley',
    rating: 5,
    text: 'I put in a last minute order and then contacted the store saying it was a gift and I needed it ASAP and they were so accommodating. I was running late due to traffic and they stayed open in consideration of my order. The people that run this shop are lovely, professional and efficient. Absolutely amazing product, I will be back!',
  },
  {
    authorName: 'Ibrahim Ahmed',
    rating: 5,
    text: 'It was very good I came into the shop and he was very friendly he broke down all the things of how it works I would reccomend to a friend',
  },
  {
    authorName: 'Leyton Bree',
    rating: 5,
    text: 'I have my leavers next monday so was in a rush for getting my shirt designed and was worried about not getting it done in time. He saved me all the relief of rushing around and said it would be finished by the next day. Cris was really nice and understood everything I had asked for. Definitely worth taking a look at and hope to return in future!',
  },
  {
    authorName: 'Claire Dawit',
    rating: 5,
    text: 'Such a lovely and helpful man. We went in with a very last minute order as we had been let down by someone else. Cris was so helpful and designed the leavers shirt ready for us to collect the next day. We cannot thank him enough and will 100% use him every time for all our printing needs in future.',
  },
  {
    authorName: 'barrington taylor',
    rating: 5,
    text: 'BAT Building Services Gas and Plumbing printed the t-shirt in Great Barr at OK T-shirt Printing and embroidery shop. Chris did a great job for my company and the printed t-shirt came exactly as I wanted.',
  },
];
